import { GlobalBusinessHealthMetric, GlobalBusinessHealthMetrics } from '../types';

const getGlobalMetricsByGroup = (
    metrics: GlobalBusinessHealthMetrics | undefined,
    group: string,
): Array<[string, GlobalBusinessHealthMetric]> => {
    if (!metrics) return [];
    return Object.entries(metrics).filter(([, row]) => row.group === group);
};

export default getGlobalMetricsByGroup;
